/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'ssl-profile-list';
const prefix = `${moduleName}.${componentName}`;

export const columnTitleAcceptedVersions = `${prefix}.columnTitleAcceptedVersions`;

export const ENGLISH = {
    [columnTitleAcceptedVersions]: 'Accepted Versions',
};
